import { fetchWithToken } from "../../interceptors/fetchInterceptor";

import {
  GET_GOROD_BY_AGENT_DATA,
  GET_GOROD_DATA,
  GET_RAYON_BY_AGENT_DATA,
  GET_RAYON_DATA,
} from "../types";
import {
  API_GET_DICTIONARY_GOROD_FOR_RAYON,
  API_GET_DICTIONARY_RAYON_FOR_OBL,
  API_GET_GOROD_BY_OBL,
  API_GET_RAYONS_BY_GOROD_ID,
  MAIN_URL,
  PORT,
} from "../../constants/constants";

export const getRayonByOblast = (id, agent = 1) => {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL + PORT + API_GET_DICTIONARY_RAYON_FOR_OBL + id,
    );

    const data = await response.json();

    const dataValid = data.map((item) => {
      return {
        ...item,
        value: item.id,
        label: item.name2,
      };
    });

    if (agent === 1) {
      dispatch({
        type: GET_RAYON_DATA,
        data: dataValid,
      });
    }
    if (agent === 2) {
      dispatch({
        type: GET_RAYON_BY_AGENT_DATA,
        data: dataValid,
      });
    }
  };
};

export const getGorodByObl = (id, agent = 1) => {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL + PORT + API_GET_GOROD_BY_OBL + "?oblId=" + id,
    );

    const data = await response.json();

    const dataValid = data.map((item) => {
      return {
        ...item,
        value: item.id,
        label: item.name2,
      };
    });

    if (agent === 1) {
      dispatch({
        type: GET_GOROD_DATA,
        data: dataValid,
      });
    }
    if (agent === 2) {
      dispatch({
        type: GET_GOROD_BY_AGENT_DATA,
        data: dataValid,
      });
    }
  };
};

export const getRayonsByGorodId = (value, agent = 1) => {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL + PORT + API_GET_RAYONS_BY_GOROD_ID + value,
    ).catch((err) => console.log(err));
    if (response.ok) {
      const data = await response.json();
      const dataValid = data.map((item) => {
        return {
          ...item,
          value: item.id,
          label: item.name2,
        };
      });

      if (agent === 1) {
        dispatch({
          type: GET_RAYON_DATA,
          data: dataValid,
        });
      }
      if (agent === 2) {
        dispatch({
          type: GET_RAYON_BY_AGENT_DATA,
          data: dataValid,
        });
      }
    }
  };
};

export const getGorodIdByRayons = (value, agent) => {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL + PORT + API_GET_DICTIONARY_GOROD_FOR_RAYON + value,
    ).catch((err) => console.log(err));
    if (response.ok) {
      const data = await response.json();
      const dataValid = data.map((item) => {
        return {
          ...item,
          value: item.id,
          label: item.name2,
        };
      });

      if (agent === 1) {
        dispatch({
          type: GET_GOROD_DATA,
          data: dataValid,
        });
      }
      if (agent === 2) {
        dispatch({
          type: GET_GOROD_BY_AGENT_DATA,
          data: dataValid,
        });
      }
    }
  };
};
